import { useMemo } from "react";

import { Box, Divider, Icon, Typography } from "@luce/ui";

import { formatLineItemAmount, groupLineItems } from "../line-items";
import { usePackageDetailContext } from "../package-detail-context";
import { PackageSection } from "./package-section";

export function PackageLineItems() {
  const { packageDetail } = usePackageDetailContext();
  const groups = useMemo(
    () => groupLineItems(packageDetail.packageLineItems),
    [packageDetail.packageLineItems],
  );

  return (
    <>
      <Divider />
      <PackageSection icon="Notepad" title="Items">
        <Box className="gap-spacing-sm flex flex-col">
          {groups.map(([serviceTitle, items]) => (
            <Box key={serviceTitle} className="gap-spacing-xs flex flex-col">
              <Box className="gap-spacing-sm flex flex-row items-center">
                <Icon name="Sparkle" size={12} weight="fill" className="text-luce-brand-primary" />
                <Typography variant="body-sm" color="neutral-foreground-default" className="flex-1">
                  {serviceTitle}
                </Typography>
              </Box>
              {items.map((item) => (
                <Box
                  key={item.packageDetailId}
                  className="gap-spacing-xs pl-spacing-md border-luce-neutral-border-highEmphasis ml-1.5 flex flex-row items-start border-l"
                >
                  <Typography
                    variant="body-sm"
                    color="neutral-foreground-intermediate"
                    className="flex-1"
                  >
                    {item.description}
                  </Typography>
                  <Typography variant="body-sm" color="neutral-foreground-default">
                    {formatLineItemAmount(item)}
                  </Typography>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </PackageSection>
    </>
  );
}
